import { Outlet, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'motion/react'
import { ChromeShell, usePageEngagement, useReturnVisitTracker } from '@gjl/studio-chrome'
import { StudioChromeProvider } from '@/components/chrome-config'
import { Breadcrumbs, generateBreadcrumbs, breadcrumbLabels } from '@/components/Breadcrumbs'
import { PageTransition } from '@/components/PageTransition'
import { useLenis } from '@gjl/motion/css'

export default function MainLayout() {
  // Initialize smooth scrolling
  useLenis()
  // GA4 engagement tracking
  usePageEngagement()
  useReturnVisitTracker()
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  // Generate breadcrumbs from current path
  const breadcrumbItems = generateBreadcrumbs(location.pathname, breadcrumbLabels)

  return (
    <StudioChromeProvider>
      <ChromeShell
        // Show breadcrumbs on all pages except homepage
        breadcrumbs={!isHomePage && breadcrumbItems.length > 0 ? <Breadcrumbs items={breadcrumbItems} /> : undefined}
      >
        <AnimatePresence mode="wait">
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </ChromeShell>
    </StudioChromeProvider>
  )
}
